import { render, staticRenderFns } from "./foremanInfo.vue?vue&type=template&id=19d8679d&scoped=true&"
import script from "./foremanInfo.vue?vue&type=script&lang=js&"
export * from "./foremanInfo.vue?vue&type=script&lang=js&"
import style0 from "./foremanInfo.vue?vue&type=style&index=0&id=19d8679d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8679d",
  null
  
)

component.options.__file = "foremanInfo.vue"
export default component.exports